import { FC } from 'react';

import styles from 'src/styles/common/expiredCampaigns.module.scss';
import { useTHelper } from 'src/utils/i18n';
import { UiOuterLink } from 'src/components/UI/OuterLink';

type Props = {
  Title: string;
  EndDate: string;
  Url: string;
};

export const ExpiredCampaignsItem: FC<Props> = ({ Title, EndDate, Url }) => {
  const tHelper = useTHelper('modals.expiredCampaigns');

  return (
    <div className={styles.campaign} role="presentation">
      <div className={styles.title}>{Title}</div>
      <div className={styles.description}>
        <div className={styles.ennDate}>{tHelper('endDate', { date: EndDate })}</div>
        <UiOuterLink className={styles.manageLink} href={Url}>
          {tHelper('manage')}
        </UiOuterLink>
      </div>
    </div>
  );
};
